<template>
  <Modal
    v-model="openPaiban"
    title="排班时间"
    footer-hide
    width="400"
    @on-cancel="cliclCancelBtn"
  >
    <ly-group>
      <ul id="dsdsdfcs">
        <li v-for="(item, index) in classesList" :key="index">
          <div style="width: 150px">
            <Tag>第{{ index + 1 }}班</Tag>
          </div>
          <Select v-model="item.startTime">
            <Option v-for="(x, index) in $t('times')" :value="x" :key="index">{{
              x
            }}</Option>
          </Select>
          <Select v-model="item.endTime">
            <Option v-for="(x, index) in $t('times')" :value="x" :key="index">{{
              x
            }}</Option>
          </Select>
          <Button @click="del(index)" style="width: 100px">删除</Button>
        </li>
      </ul>
    </ly-group>
    <div class="clearfloat">
      <div style="float: left">
        <Button @click="add">新增排班</Button
        ><Button @click="clear">清空排班</Button>
      </div>
      <div style="float: right">
        <Button type="primary" @click="addUpdate('item')">提交表单</Button>
      </div>
    </div>
  </Modal>
</template>
<script>
export default {
  props: ["classesList"],
  data() {
    return {
      openPaiban: false,
      columns1: [
        {
          title: "开始时间",
          slot: "startTime",
        },
        {
          title: "结束时间",
          slot: "endTime",
        },
        {
          title: "操作",
          slot: "del",
        },
      ],
      item: {},
    };
  },
  methods: {
    add() {
      var obj = {
        startTime: "9:00",
        endTime: "9:00",
      };
      this.classesList.push(obj);
    },
    del(index) {
      this.classesList.splice(index, 1);
    },
    clear() {
      this.classesList.splice(0, this.classesList.length);
    },
    open() {
      this.openPaiban = true;
    },
    addUpdate(v) {
      this.$emit("classesLis", this.classesList);
      console.log(this.classesLis);
    },
    close() {
      this.openPaiban = false;
    },
    cliclCancelBtn() {},
    resetForm() {},
  },
};
</script>
<style>
#dsdsdfcs li {
  display: flex;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/carsys/classesList.vue